// frontend/src/components/common/InfoIcon.jsx
import React, { useState } from "react";

/**
 * InfoIcon
 *
 * Props:
 * - message: string (required)  — message to show in tooltip on hover/focus
 * - docsUrl: string (optional)
 * - className: string (optional)
 *
 * Usage:
 *  <InfoIcon message="Unused credits will carry forward…" />
 */

const tooltipStyle = {
    position: "absolute",
    zIndex: 9999,
    minWidth: 220,
    maxWidth: 360,
    padding: "8px 10px",
    borderRadius: 6,
    background: "white",
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
    color: "#111827",
    fontSize: 13,
    lineHeight: "1.25",
    border: "1px solid rgba(0,0,0,0.06)",
    whiteSpace: "pre-line"   // 👈 THIS MAKES \n WORK
};

export default function InfoIcon({ message, docsUrl, className = "" }) {
    const [visible, setVisible] = useState(false);
    const id = `info-${Math.random().toString(36).slice(2, 9)}`;

    return (
        <span
            className={`inline-block relative ${className}`}
            onMouseEnter={() => setVisible(true)}
            onMouseLeave={() => setVisible(false)}
            onFocus={() => setVisible(true)}
            onBlur={() => setVisible(false)}
            tabIndex={0}
            aria-describedby={visible ? id : undefined}
            aria-label={message}     // accessible name for screen readers (no native tooltip)
            style={{ outline: "none" }}
            role="button"
        >
            {/* small circular 'i' icon */}
            <span
                aria-hidden="true"
                style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 18,
                    height: 18,
                    borderRadius: 18,
                    background: "#eef2ff",
                    color: "#3730a3",
                    fontSize: 12,
                    fontWeight: 600,
                    cursor: "pointer",
                    border: "1px solid rgba(0,0,0,0.04)"
                }}
            >
                i
            </span>

            {/* Tooltip */}
            {visible && (
                <div
                    id={id}
                    role="tooltip"
                    style={{
                        ...tooltipStyle,
                        top: "calc(100% + 8px)",
                        right: 0,
                        textAlign: "left"
                    }}
                >
                    <div>{message}</div>

                </div>
            )}
        </span>
    );
}
